export enum SopType {
	TRANSFORM = 'transform',
}
